import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/finally';
import { Subscription } from 'rxjs/Subscription';
import { ProcessService } from 'app/core/process/process.service';
import * as Models from 'app/core/models';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { ModalService } from 'app/modal/modal.service';


@Component({
  selector: 'app-search-processes',
  templateUrl: './searchProcesses.component.html',
  styleUrls: ['./searchProcesses.component.scss']
})
export class SearchProcessesComponent implements OnInit, OnDestroy  {
  subscription: Subscription;
  searchQuery: string;
  processPerRow = 4;
  processes: Models.Process[];
  isLoading: boolean;
  createdByImageUrl: boolean;
  moreProcessesLeft: boolean;
  loading = false;
  pageNumber: number;
  totalItemsCount: number;
  title: string;
  private PAGE_SIZE = 20;

  constructor(private processService: ProcessService,
              private authenticationService: AuthenticationService,
              private router: Router,
              private actRoute: ActivatedRoute,
              private modalService: ModalService) {

    window.onresize = (e) => {
      this.onResize();
    };
  }

  ngOnInit() {
    this.processes = [];
    this.pageNumber = 0;
    this.totalItemsCount = 0;
    this.processPerRow = this.calculateProcessPerRow();

    this.subscription = this.actRoute.params.subscribe(params => {
      const query: string = params['searchQuery'];
      if (query) {
        this.searchQuery = query;
        this.processes = [];
        this.pageNumber = 0;
        this.totalItemsCount = 0;

        this.loading = true;
        this.getProcesses();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getProcesses(): void {
    this.isLoading = true;
    this.processService.getGroups(Models.ProcessGroups.Recents, this.PAGE_SIZE, this.pageNumber + 1, this.searchQuery)
      .finally(() => {
        this.isLoading = false;
        this.loading = false;
      })
      .subscribe((result: Models.PagedList<Models.Process>) => {
        this.pageNumber = result.pageNumber;
        this.totalItemsCount = result.totalItemsCount;
        this.addNewItemsToList(result.items, this.processes);
      });
  }

  addNewItemsToList(items: Array<Models.Process>, list: Array<Models.Process>): void {
    items.forEach(element => {
      if (list.find(x => x.processId === element.processId) == null) {
        element.color = this.randomColor();
        element.createdByInitials = element.createdBy ?
          element.createdBy.split(' ')
            .map((n: string) => n
              .substr(0, 1))
            .slice(0, 2).join('') : '';
        list.push(element);
      }
    });
  }

  randomColor(): string {
    return (Math.floor(Math.random() * (6)) + 1).toString();
  }

  preview(processId: number) {
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      this.router.navigate(['/process/preview/', processId]);
    }
  }

  run($event: Event, processId: number) {
    $event.stopPropagation();
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      this.router.navigate(['/process/execute/', processId]);
    }
  }

  calculateProcessPerRow(): number {
    const width = window.innerWidth;
    let newprocessPerRow;
    if (width >= 1200) {
      newprocessPerRow = 4;
    } else if (width >= 500) {
      newprocessPerRow = 3;
    } else {
      newprocessPerRow = 2;
    }
    return newprocessPerRow;
  }

  onResize() {
    this.processPerRow = this.calculateProcessPerRow();
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }
}






// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/searchProcesses/searchProcesses.component.ts